module.exports = __webpack_public_path__ + "static/media/BATool-logo-1.7e619dbf.svg";